import { Tc } from '../../../core/_infrastructure/types/common';
import { TUsuarioExternoViewModel, TSolicitanteAdministrativoViewModel } from '../../../_importacion/solicitudes/datosbasicos/datosbasicos.types';
import { TwEnvioEphytoViewModel } from '../../../core/_infrastructure/types/web.services';
import { TPreviaInspectorSolicitudExViewModel } from '../previaInspector/previaInspectorEx.types';

export class SolicitudExViewModel {
    constructor() {}

    public Id: number;
    public Codigo: string;
    public IdPuntoInspeccion = 0;
    public IdTipoSolicitudEx = 0;
    public IdEstadoSolicitudEx = 0;
    public IdEstadoCertificadoFitoEx = 0;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public IdIdioma = 0;
    public IdiomaDescripcion: string;
    public EsPrevia = false;
    public VieneDePreviaAceptada: boolean | null = false;
    public TieneAlegacion = false;
    public FechaDesde: Date;
    public FechaHasta: Date;
    public FechaEnvio: Date | null;
    public HoraEnvio: string;
    public RazonSocial = '';
    public ApellidosInspector = '';
    public NombreInspector = '';
    public RefSolicitante = '';
    public FechaCreacion: Date;
    public FechaPresentacion: Date | null;
    public IdUsuarioSolicitante: number | null = null;
    public IdInspector: number | null = null;
    public AplicaTasa: boolean;
    public EsEphyto: boolean;
    public IdUsuarioSolicitanteAdministrativo: number | null = null;
    //public IdUsuarioGrabador: number | null = null;
    public IdFormatoSolicitudEx = 0;
    public NumeroCertificado: string;
    public FechaCertificacion: Date | null;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;
    public AtestacionFito: boolean;

    public ListSolicitudesAtestacionFito: number[];

    public Enviando = false;

    public TExportadorEx: TExportadorExViewModel = new TExportadorExViewModel();
    public TDestinatarioEx: TDestinatarioExViewModel = new TDestinatarioExViewModel();
    public TwUsuarioExterno: TUsuarioExternoViewModel = new TUsuarioExternoViewModel();
    public TSolicitanteAdministrativo: TSolicitanteAdministrativoViewModel;
    public TSolicitudAdministrativoEx: TSolicitudAdministrativoExViewModel;
    public TCampaniasDatosSolicEx: TCampaniasDatosSolicExViewModel;
    public TPreviaInspectorEx: TPreviaInspectorSolicitudExViewModel;
    public TLugarMercanciaEx: TLugarMercanciaExViewModel = new TLugarMercanciaExViewModel();
    public TMedioTransporteEx: TMedioTransporteExViewModel = new TMedioTransporteExViewModel();

    public TwEphyto: TwEphytoViewModel = new TwEphytoViewModel();
    public TwEnvioEphytoCollection: TwEnvioEphytoViewModel[];

    public TwTerminosCondicionesEx: TwTerminosCondicionesExViewModel = new TwTerminosCondicionesExViewModel();
    public TcTipoSolicitudEx: TcTipoSolicitudExViewModel = new TcTipoSolicitudExViewModel();
    public TcEstadoSolicitudEx: Tc;
    public TwTcEstadoCertificadoFitoEx: Tc;
    //public TPuntoInspeccion: PuntoInspeccionViewModel = new PuntoInspeccionViewModel();//necesario para generar el codigo solicitud en el Service
    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel = new TwSolicitudJerarquiaExViewModel();
    public TClaveCertCanarias: TClaveCertCanariasViewModel;
}

export class SubTipoSolicitudExViewModel {
    public Id: number;
    public IdTipoSolicitudEx: number;
    public Descripcion: string;
    public ConAtestacionFito: boolean;
    public ConAvisoConfeccion: boolean;
}

export class ParametrosNuevaSolicitudExViewModel {
    public IdTipoSolicitudEx: number;
    public IdSubTipoSolicitudEx: number;
    public tipoSolicitudEx: string;
    public IdPuntoInspeccion: number;
    public IdPaisDestino: number;
    public IdUbicacion: number | null = null;
    public IdInstalacionAutorizada: number | null = null;
    public IdIdioma: number;
    public IdCampania: number;
    public IdPeriodo: number;
    public AvisoConfeccion: boolean;
    public esPrevia: boolean;
    public esAtestacionFitosanitaria: boolean;
}

export class TwEphytoViewModel {
    public IdSolicitudEx: number;
    public IdEstado: number;
    public IdEstadoDescripcion: string;
    public Codigo: string;
    public Fecha: Date | null;
}

export class TwSolicitudJerarquiaExViewModel {
    public IdSolicitudEx: number;
    public IdSolicitudPadre: number;
    public IdTipoClonacion: number;
    public Guardada: boolean;
}

export class TcTipoSolicitudExViewModel {
    public Id: number;
    public Descripcion: string;
    public Codigo: string;
    public Activo: boolean;
}

export class TwTerminosCondicionesExViewModel {
    public IdSolicitudEx: number;
    public PermisoOLicenciaImp: boolean;
    public NormativaFito: boolean;
    public AceptarDeclaracion: boolean;
}

export class TLugarMercanciaExViewModel {
    public IdSolicitudEx: number;
    public IdPaisOrigen: number;
    public IdPaisDestino: number;
    public IdUbicacion: number;
    public PuntoEntradaDeclarado: string;
    public IdPuntoEntradaRusia: number;
    public LugarOrigen: string;
    public FechaInspeccion: Date;
    public IdIntervaloHoras: number;
    public IdInstalacionAutorizada: number;
    public IdPaisPuntoEntradaUnlocode: number;
    public IdUnlocodeLocation: number;
    public PaisPuntoEntradaUnlocode: string;
    public UnlocodeLocation: string;
}

export class TMedioTransporteExViewModel {
    public IdSolicitudEx: number;
    public IdMedioTransporte: number;
    public NumeroOMI: string;
    public IdTipoEnvio: number;
}

export class TExportadorExViewModel {
    public IdSolicitudEx: number;
    public NifExportador: string;
    public NombreExportador: string;
    public LocalidadExportador: string;
    public IdPaisExportador: number;
    public DireccionExportador: string;
    public CodigoPostalExportador: string;
}

export class TDestinatarioExViewModel {
    public IdSolicitudEx: number;
    public NifDestinatario: string;
    public NombreDestinatario: string;
    public CiudadDestinatario: string;
    public IdPaisDestinatario: number;
    public DireccionDestinatario: string;
    public CodigoPostalDestinatario: string;
    public NumeroAfidi: string;
}

//export class TSolicitanteAdministrativoViewModel {
//    public Id: number;
//    public NifSolicitanteAdministrativo: string;
//    public RazonSocialSolicitanteAdministrativo: string;
//    public NumeroTelefonoSolicitanteAdministrativo: string;
//}

export class TSolicitudAdministrativoExViewModel {
    public IdSolicitudEx: number;
    public IdUsuarioGrabador: number;
    public FechaRegistro: Date | null;
    public NRegistroPapel: string;
}

export class TCampaniasDatosSolicExViewModel {
    public IdSolicitudEx: number;
    public IdPeriodo: number;
    public IdEstadoAvisoConfeccion: number | null;
    public Observaciones: string;
}

export class TClaveCertCanariasViewModel {
    public IdSolicitudEx: number;
    public Certificado: string;
    public Pin: number;
}
